import React from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { Alert, Button } from "components/bootstrap";
import IndexRangeSummary from "components/indices/IndexRangeSummary";
import { INDICES_QUERY_KEY, reopenIndex, deleteIndex } from "hooks/useIndices";
const ClosedIndexDetails = ({ indexName, indexRange = void 0 }) => {
  const { t } = useTranslation("indexsets");
  const queryClient = useQueryClient();
  const _invalidate = () => queryClient.invalidateQueries({ queryKey: INDICES_QUERY_KEY });
  const _onReopen = () => {
    reopenIndex(indexName).then(_invalidate);
  };
  const _onDeleteIndex = () => {
    if (window.confirm(t("indices.closed_index.confirm_delete", { indexName }))) {
      deleteIndex(indexName).then(_invalidate);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "index-info" }, /* @__PURE__ */ React.createElement(IndexRangeSummary, { indexRange }), /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, t("indices.closed_index.info")), /* @__PURE__ */ React.createElement("hr", { style: { marginBottom: "5", marginTop: "10" } }), /* @__PURE__ */ React.createElement(Button, { bsStyle: "warning", bsSize: "xs", onClick: _onReopen }, t("indices.closed_index.reopen")), " ", /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xs", onClick: _onDeleteIndex }, t("indices.closed_index.delete")));
};
export default ClosedIndexDetails;
